module.exports = __webpack_public_path__ + "static/media/8.ca2dbc2c.png";